/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorize-package.vue?vue&type=template&id=10cedf5c&scoped=true&"
import script from "./authorize-package.vue?vue&type=script&lang=js&"
export * from "./authorize-package.vue?vue&type=script&lang=js&"
import style0 from "./authorize-package.vue?vue&type=style&index=0&id=10cedf5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cedf5c",
  null
  
)

export default component.exports